import axios from 'axios'
import type { MobileRateCheckPeriods } from '@numeo/types'

interface Envelope<T> {
    success: boolean
    data: T
    message?: string
}

export const mobileRateCheckApi = {
    get: async (): Promise<MobileRateCheckPeriods> => {
        const res = await axios.get<Envelope<MobileRateCheckPeriods>>('/gluon/config/mobile-rate-check')
        return res.data.data
    },

    set: async (periods: MobileRateCheckPeriods): Promise<MobileRateCheckPeriods> => {
        const res = await axios.put<Envelope<MobileRateCheckPeriods>>('/gluon/config/mobile-rate-check', periods)
        return res.data.data
    },
}
